// extracted by mini-css-extract-plugin
module.exports = {"countryFlagWrapper":"styles_countryFlagWrapper__38oXR"};